// AUTO-GENERATED by shared/generators/entity_urls_generator.py — do not edit by hand.
// Source: shared/config/modules_entities.config.json

import type { EntityUrlEntry } from './entry';

export const ENTITY_URL_REGISTRY: Record<string, EntityUrlEntry> = {
  "accounting.account": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "accounting.bank_account": {
    urlTemplate: "/accounting/banking/accounts/{id}",
  },
  "accounting.bank_deposit": {
    urlTemplate: "/accounting/banking/deposits/{id}",
  },
  "accounting.bill": {
    urlTemplate: "/accounting/bills/{id}",
  },
  "accounting.claim": {
    urlTemplate: "/accounting/claims/{id}",
  },
  "accounting.finance_charge_run": {
    urlTemplate: "/accounting/finance-charges/{id}",
  },
  "accounting.invoice": {
    urlTemplate: "/accounting/invoices/{id}",
  },
  "accounting.journal_entry": {
    urlTemplate: "/accounting/journal-entries/{id}",
  },
  "accounting.payment": {
    urlTemplate: "/accounting/payments/{id}",
  },
  "accounting.payment_run": {
    urlTemplate: "/accounting/payment-runs/{id}",
  },
  "accounting.recurring_template": {
    urlTemplate: "/accounting/recurring",
  },
  "accounting.vendor_statement": {
    urlTemplate: "/accounting/vendor-statements/{id}",
  },
  "accounting_accounts": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "accounting_bank_accounts": {
    urlTemplate: "/accounting/banking/accounts/{id}",
  },
  "accounting_bank_deposits": {
    urlTemplate: "/accounting/banking/deposits/{id}",
  },
  "accounting_bills": {
    urlTemplate: "/accounting/bills/{id}",
  },
  "accounting_claims": {
    urlTemplate: "/accounting/claims/{id}",
  },
  "accounting_finance_charge_runs": {
    urlTemplate: "/accounting/finance-charges/{id}",
  },
  "accounting_invoices": {
    urlTemplate: "/accounting/invoices/{id}",
  },
  "accounting_journal_entries": {
    urlTemplate: "/accounting/journal-entries/{id}",
  },
  "accounting_payment_runs": {
    urlTemplate: "/accounting/payment-runs/{id}",
  },
  "accounting_payments": {
    urlTemplate: "/accounting/payments/{id}",
  },
  "accounting_recurring_templates": {
    urlTemplate: "/accounting/recurring",
  },
  "accounting_vendor_statements": {
    urlTemplate: "/accounting/vendor-statements/{id}",
  },
  "accounts": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "adjustment": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "agent_pending_approvals": {
    urlTemplate: "/ai-agents/approvals",
    urlContextTemplate: "/ai-agents/{agent_id}/supervision",
  },
  "agents": {
    urlTemplate: "/ai-agents/{id}",
  },
  "ai_agents": {
    urlTemplate: "/ai-agents/{id}",
  },
  "ai_agents.agent": {
    urlTemplate: "/ai-agents/{id}",
  },
  "ai_agents.agent_pending_approval": {
    urlTemplate: "/ai-agents/approvals",
    urlContextTemplate: "/ai-agents/{agent_id}/supervision",
  },
  "ai_chat.chat": {
    urlTemplate: "/ai-chat?session={id}",
  },
  "billing.billing_account": {
    urlTemplate: "/billing/accounts/{id}",
  },
  "billing_account": {
    urlTemplate: "/billing/accounts/{id}",
  },
  "billing_accounts": {
    urlTemplate: "/billing/accounts/{id}",
  },
  "bkr_aggregations": {
    urlTemplate: "/brokerage/aggregations/{id}",
  },
  "bkr_bids": {
    urlTemplate: "/brokerage/bids/{id}",
  },
  "bkr_offer_sheets": {
    urlTemplate: "/brokerage/offer-sheets/{id}",
  },
  "board": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "boards": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "brokerage.bkr_aggregation": {
    urlTemplate: "/brokerage/aggregations/{id}",
  },
  "brokerage.bkr_bid": {
    urlTemplate: "/brokerage/bids/{id}",
  },
  "brokerage.bkr_offer_sheet": {
    urlTemplate: "/brokerage/offer-sheets/{id}",
  },
  "brokerage_aggregations": {
    urlTemplate: "/brokerage/aggregations/{id}",
  },
  "brokerage_bids": {
    urlTemplate: "/brokerage/bids/{id}",
  },
  "brokerage_offer_sheets": {
    urlTemplate: "/brokerage/offer-sheets/{id}",
  },
  "categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "cfs_receipts": {
    urlTemplate: "/shipments/cfs/{id}",
  },
  "chatbot.chatbot_bot": {
    urlTemplate: "/chatbot/bots/{id}",
  },
  "chatbot.chatbot_channel": {
    urlTemplate: "/chatbot/bots",
    urlContextTemplate: "/chatbot/bots/{bot_id}?tab=channels",
  },
  "chatbot.chatbot_conversation": {
    urlTemplate: "/chatbot/inbox?conversation={id}",
  },
  "chatbot_bot": {
    urlTemplate: "/chatbot/bots/{id}",
  },
  "chatbot_bots": {
    urlTemplate: "/chatbot/bots/{id}",
  },
  "chatbot_channel": {
    urlTemplate: "/chatbot/bots",
    urlContextTemplate: "/chatbot/bots/{bot_id}?tab=channels",
  },
  "chatbot_conversation": {
    urlTemplate: "/chatbot/inbox?conversation={id}",
  },
  "chatbot_conversations": {
    urlTemplate: "/chatbot/inbox?conversation={id}",
  },
  "chats": {
    urlTemplate: "/ai-chat?session={id}",
  },
  "claims": {
    urlTemplate: "/accounting/claims/{id}",
  },
  "companies": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "company": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "consols": {
    urlTemplate: "/shipments/consols/{id}",
  },
  "contacts": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "contacts_contacts": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "contacts_organizations": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "contacts_tiers": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "contract": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "contracts": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "contracts.contract": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "contracts.contract_clause": {
    urlTemplate: "/contracts/clauses/{id}",
  },
  "contracts.contract_template": {
    urlTemplate: "/contracts/templates/{id}",
  },
  "contracts.signature": {
    urlTemplate: "/sign",
  },
  "contracts_clauses": {
    urlTemplate: "/contracts/clauses/{id}",
  },
  "contracts_templates": {
    urlTemplate: "/contracts/templates/{id}",
  },
  "ctr_clauses": {
    urlTemplate: "/contracts/clauses/{id}",
  },
  "ctr_contracts": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "ctr_signatures": {
    urlTemplate: "/sign",
  },
  "ctr_templates": {
    urlTemplate: "/contracts/templates/{id}",
  },
  "customs_entries": {
    urlTemplate: "/shipments/customs/{id}",
  },
  "deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "employees": {
    urlTemplate: "/people/employees/{id}",
  },
  "exception_fingerprint": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "fbpm_business_processes": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "fbpm_form_submissions": {
    urlTemplate: "/forms-bpm/submissions/{id}",
  },
  "fbpm_forms": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "fbpm_process_instances": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "fbpm_scorecards": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "file_management.file": {
    urlTemplate: "/files?file={id}",
  },
  "file_management.folder": {
    urlTemplate: "/files?folder={id}",
  },
  "files": {
    urlTemplate: "/files?file={id}",
  },
  "folders": {
    urlTemplate: "/files?folder={id}",
  },
  "forms_bpm.fbpm_business_process": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "forms_bpm.fbpm_form": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "forms_bpm.fbpm_form_submission": {
    urlTemplate: "/forms-bpm/submissions/{id}",
  },
  "forms_bpm.fbpm_process_instance": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "forms_bpm.fbpm_scorecard": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "forms_bpm_business_processes": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "forms_bpm_forms": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "forms_bpm_process_instances": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "forms_bpm_scorecards": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "forms_bpm_submissions": {
    urlTemplate: "/forms-bpm/submissions/{id}",
  },
  "frst_agents": {
    urlTemplate: "/shipments/freight-settlements/{id}",
  },
  "frst_settlement_runs": {
    urlTemplate: "/shipments/freight-settlements/runs/{id}",
  },
  "inv_stock_adjustments": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "inv_stock_takes": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "inv_stock_transfers": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "inventory.stock_adjustment": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "inventory.stock_take": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "inventory.stock_transfer": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "inventory_adjustments": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "inventory_transfers": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "item": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "marketing.newsletter": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "marketing.newsletter_issue": {
    urlTemplate: "/marketing/newsletters/{newsletter_id}/issues/{id}",
  },
  "marketing_newsletters": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "master_data.company": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "master_data.contact": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "master_data.offering": {
    urlTemplate: "/master-data/offerings/{id}",
  },
  "master_data.price_list": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "master_data.product": {
    urlTemplate: "/master-data/products/{id}",
  },
  "master_data.product_category": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "master_data.product_packaging": {
    urlContextTemplate: "/master-data/products/{product_id}?tab=packaging",
  },
  "master_data.tier": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "master_data_contacts_organizations": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "master_data_contacts_people": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "master_data_offerings": {
    urlTemplate: "/master-data/offerings/{id}",
  },
  "master_data_products_products": {
    urlTemplate: "/master-data/products/{id}",
  },
  "messaging.messaging_conversation": {
    urlTemplate: "/messaging?conversation={id}",
  },
  "messaging_conversations": {
    urlTemplate: "/messaging?conversation={id}",
  },
  "mkt_newsletter_issues": {
    urlTemplate: "/marketing/newsletters/{newsletter_id}/issues/{id}",
  },
  "mkt_newsletters": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "newsletter": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "offerings": {
    urlTemplate: "/master-data/offerings/{id}",
  },
  "organizations": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "people.people_employee": {
    urlTemplate: "/people/employees/{id}",
  },
  "people.people_goal": {
    urlTemplate: "/people/goals/{id}",
  },
  "people.people_onboarding_template": {
    urlContextTemplate: "/people/{kind}/templates/{id}",
  },
  "people.people_one_on_one": {
    urlTemplate: "/people/one-on-ones/{id}",
  },
  "people.people_recognition": {
    urlTemplate: "/people/feedback?tab=recognition&recognition={id}",
  },
  "people.people_report_definition": {
    urlTemplate: "/people/reports/{id}",
  },
  "people.people_review_cycle": {
    urlTemplate: "/people/reviews/{id}",
  },
  "people.people_survey": {
    urlTemplate: "/people/surveys/{id}",
  },
  "people.people_survey_wave": {
    urlContextTemplate: "/people/surveys/{survey_id}/waves/{id}",
  },
  "people_employees": {
    urlTemplate: "/people/employees/{id}",
  },
  "people_goals": {
    urlTemplate: "/people/goals/{id}",
  },
  "people_onboarding_templates": {
    urlContextTemplate: "/people/{kind}/templates/{id}",
  },
  "people_one_on_ones": {
    urlTemplate: "/people/one-on-ones/{id}",
  },
  "people_recognition": {
    urlTemplate: "/people/feedback?tab=recognition&recognition={id}",
  },
  "people_report_definitions": {
    urlTemplate: "/people/reports/{id}",
  },
  "people_reports": {
    urlTemplate: "/people/reports/{id}",
  },
  "people_review_cycles": {
    urlTemplate: "/people/reviews/{id}",
  },
  "people_reviews": {
    urlTemplate: "/people/reviews/{id}",
  },
  "people_survey_waves": {
    urlContextTemplate: "/people/surveys/{survey_id}/waves/{id}",
  },
  "people_surveys": {
    urlTemplate: "/people/surveys/{id}",
  },
  "pipeline.deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline.pipeline_deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline.pipeline_outreach_task": {
    urlTemplate: "/pipeline/prospecting/tasks",
  },
  "pipeline.pipeline_sequence": {
    urlTemplate: "/pipeline/prospecting/sequences/{id}",
  },
  "pipeline_deals": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline_leads": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "pipeline_outreach_tasks": {
    urlTemplate: "/pipeline/prospecting/tasks",
  },
  "pipeline_sequences": {
    urlTemplate: "/pipeline/prospecting/sequences/{id}",
  },
  "price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "proc_goods_receipts": {
    urlTemplate: "/procurement/goods-receipts/{id}",
  },
  "proc_purchase_orders": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "proc_purchase_requisitions": {
    urlTemplate: "/procurement/requisitions/{id}",
  },
  "proc_recurring_po_templates": {
    urlTemplate: "/procurement/recurring-pos",
  },
  "proc_rfqs": {
    urlTemplate: "/procurement/rfqs/{id}",
  },
  "proc_supplier_claims": {
    urlTemplate: "/procurement/supplier-claims",
  },
  "proc_supplier_pis": {
    urlTemplate: "/procurement/supplier-pis/{id}",
  },
  "proc_vendor_profiles": {
    urlTemplate: "/procurement/vendors/{id}",
  },
  "proc_vendor_returns": {
    urlTemplate: "/procurement/vendor-returns/{id}",
  },
  "procurement.goods_receipt": {
    urlTemplate: "/procurement/goods-receipts/{id}",
  },
  "procurement.purchase_order": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "procurement.purchase_requisition": {
    urlTemplate: "/procurement/requisitions/{id}",
  },
  "procurement.recurring_po_template": {
    urlTemplate: "/procurement/recurring-pos",
  },
  "procurement.rfq": {
    urlTemplate: "/procurement/rfqs/{id}",
  },
  "procurement.supplier_claim": {
    urlTemplate: "/procurement/supplier-claims",
  },
  "procurement.supplier_pi": {
    urlTemplate: "/procurement/supplier-pis/{id}",
  },
  "procurement.vendor_profile": {
    urlTemplate: "/procurement/vendors/{id}",
  },
  "procurement.vendor_return": {
    urlTemplate: "/procurement/vendor-returns/{id}",
  },
  "procurement_orders": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "procurement_receipts": {
    urlTemplate: "/procurement/goods-receipts/{id}",
  },
  "procurement_requisitions": {
    urlTemplate: "/procurement/requisitions/{id}",
  },
  "procurement_rfqs": {
    urlTemplate: "/procurement/rfqs/{id}",
  },
  "procurement_supplier_pis": {
    urlTemplate: "/procurement/supplier-pis/{id}",
  },
  "procurement_vendor_returns": {
    urlTemplate: "/procurement/vendor-returns/{id}",
  },
  "procurement_vendors": {
    urlTemplate: "/procurement/vendors/{id}",
  },
  "product_categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "product_packaging": {
    urlContextTemplate: "/master-data/products/{product_id}?tab=packaging",
  },
  "product_price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "products": {
    urlTemplate: "/master-data/products/{id}",
  },
  "products_categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "products_price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "products_products": {
    urlTemplate: "/master-data/products/{id}",
  },
  "purchase_order": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "recruiting.recruiting_application": {
    urlTemplate: "/recruiting/candidates/{candidate_id}?application={id}",
  },
  "recruiting.recruiting_candidate": {
    urlTemplate: "/recruiting/candidates/{id}",
  },
  "recruiting.recruiting_interview": {
    urlTemplate: "/recruiting/interviews/{id}",
  },
  "recruiting.recruiting_job_posting": {
    urlTemplate: "/recruiting/jobs/{id}",
  },
  "recruiting.recruiting_pipeline": {
    urlTemplate: "/recruiting/pipelines/{id}",
  },
  "recruiting_applications": {
    urlTemplate: "/recruiting/candidates/{candidate_id}?application={id}",
  },
  "recruiting_candidates": {
    urlTemplate: "/recruiting/candidates/{id}",
  },
  "recruiting_interviews": {
    urlTemplate: "/recruiting/interviews/{id}",
  },
  "recruiting_job_postings": {
    urlTemplate: "/recruiting/jobs/{id}",
  },
  "recruiting_jobs": {
    urlTemplate: "/recruiting/jobs/{id}",
  },
  "recruiting_pipelines": {
    urlTemplate: "/recruiting/pipelines/{id}",
  },
  "sales.order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales.sales_channel": {
    urlTemplate: "/sales/channels/{id}",
  },
  "sales.sales_commission_payout_run": {
    urlTemplate: "/sales/commission-payouts/{id}",
  },
  "sales.sales_commission_plan": {
    urlTemplate: "/sales/commission-plans/{id}",
  },
  "sales.sales_customer_account": {
    urlTemplate: "/sales/customers/{id}",
  },
  "sales.sales_delivery": {
    urlTemplate: "/sales/orders/{sales_order_id}?delivery={id}",
  },
  "sales.sales_order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales.sales_order_type": {
    urlTemplate: "/sales/order-types",
  },
  "sales.sales_partner": {
    urlTemplate: "/sales/partners/{id}",
  },
  "sales.sales_return": {
    urlTemplate: "/sales/returns/{id}",
  },
  "sales_channels": {
    urlTemplate: "/sales/channels/{id}",
  },
  "sales_commission_payout_runs": {
    urlTemplate: "/sales/commission-payouts/{id}",
  },
  "sales_commission_plans": {
    urlTemplate: "/sales/commission-plans/{id}",
  },
  "sales_customer_accounts": {
    urlTemplate: "/sales/customers/{id}",
  },
  "sales_customers": {
    urlTemplate: "/sales/customers/{id}",
  },
  "sales_deals": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "sales_deliveries": {
    urlTemplate: "/sales/orders/{sales_order_id}?delivery={id}",
  },
  "sales_order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales_order_types": {
    urlTemplate: "/sales/order-types",
  },
  "sales_orders": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales_partners": {
    urlTemplate: "/sales/partners/{id}",
  },
  "sales_returns": {
    urlTemplate: "/sales/returns/{id}",
  },
  "sf_changelog_entries": {
    urlTemplate: "/software-factory/changelog/{id}",
  },
  "sf_exception_fingerprints": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "sf_initiatives": {
    urlTemplate: "/software-factory/initiatives/{id}",
  },
  "sf_modules": {
    urlTemplate: "/software-factory/modules/{id}",
  },
  "sf_sprints": {
    urlTemplate: "/software-factory/sprints/{id}",
  },
  "sf_user_announcements": {
    urlTemplate: "/software-factory/announcements/{id}",
  },
  "sf_work_items": {
    urlTemplate: "/software-factory/work-items/{id}",
  },
  "shared.tenant": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "shipments": {
    urlTemplate: "/shipments/{id}",
  },
  "shipments.cfs_receipt": {
    urlTemplate: "/shipments/cfs/{id}",
  },
  "shipments.consol": {
    urlTemplate: "/shipments/consols/{id}",
  },
  "shipments.customs_entry": {
    urlTemplate: "/shipments/customs/{id}",
  },
  "shipments.freight_agent": {
    urlTemplate: "/shipments/freight-settlements/{id}",
  },
  "shipments.freight_settlement_run": {
    urlTemplate: "/shipments/freight-settlements/runs/{id}",
  },
  "shipments.shipment": {
    urlTemplate: "/shipments/{id}",
  },
  "shipments.shipment_document": {
    urlTemplate: "/shipments/documents/{id}",
    urlContextTemplate: "/shipments/{shipment_id}?tab=documents",
  },
  "shipments.shipment_estimate": {
    urlTemplate: "/shipments/estimates/{id}",
  },
  "shp_cfs_receipts": {
    urlTemplate: "/shipments/cfs/{id}",
  },
  "shp_consols": {
    urlTemplate: "/shipments/consols/{id}",
  },
  "shp_shipment_documents": {
    urlTemplate: "/shipments/documents/{id}",
    urlContextTemplate: "/shipments/{shipment_id}?tab=documents",
  },
  "shp_shipment_estimates": {
    urlTemplate: "/shipments/estimates/{id}",
  },
  "shp_shipments": {
    urlTemplate: "/shipments/{id}",
  },
  "signature_sign": {
    urlTemplate: "/sign",
  },
  "software_factory.sf_changelog_entry": {
    urlTemplate: "/software-factory/changelog/{id}",
  },
  "software_factory.sf_exception_fingerprint": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "software_factory.sf_initiative": {
    urlTemplate: "/software-factory/initiatives/{id}",
  },
  "software_factory.sf_module": {
    urlTemplate: "/software-factory/modules/{id}",
  },
  "software_factory.sf_sprint": {
    urlTemplate: "/software-factory/sprints/{id}",
  },
  "software_factory.sf_user_announcement": {
    urlTemplate: "/software-factory/announcements/{id}",
  },
  "software_factory.sf_work_item": {
    urlTemplate: "/software-factory/work-items/{id}",
  },
  "software_factory_changelog": {
    urlTemplate: "/software-factory/changelog/{id}",
  },
  "software_factory_exceptions_fingerprints": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "software_factory_initiatives": {
    urlTemplate: "/software-factory/initiatives/{id}",
  },
  "software_factory_modules": {
    urlTemplate: "/software-factory/modules/{id}",
  },
  "software_factory_sprints": {
    urlTemplate: "/software-factory/sprints/{id}",
  },
  "software_factory_work_items": {
    urlTemplate: "/software-factory/work-items/{id}",
  },
  "sprints": {
    urlTemplate: "/tasks/sprints/{id}",
  },
  "stock_take": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "support.support_kb_article": {
    urlTemplate: "/support/kb/articles/{id}",
  },
  "support.support_ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "support.ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "support_kb_articles": {
    urlTemplate: "/support/kb/articles/{id}",
  },
  "support_tickets": {
    urlTemplate: "/support/tickets/{id}",
  },
  "sysadmin.alert": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "sysadmin_alert": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "sysadmin_alerts": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "task": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.board": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "tasks.item": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.sprint": {
    urlTemplate: "/tasks/sprints/{id}",
  },
  "tasks.task": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.workspace": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
  "tasks_boards": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "tasks_sprints": {
    urlTemplate: "/tasks/sprints/{id}",
  },
  "tasks_tasks": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks_workspaces": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
  "tenant": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "tenants": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "third_party_services.user_oauth_connection": {
    urlTemplate: "/settings?tab=integrations",
  },
  "ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "tickets": {
    urlTemplate: "/support/tickets/{id}",
  },
  "tiers": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "transfer": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "user_management.join_request": {
    urlTemplate: "/admin/join-requests",
  },
  "user_management.user": {
    urlTemplate: "/admin/users/{id}",
  },
  "user_management_join_requests": {
    urlTemplate: "/admin/join-requests",
  },
  "user_oauth_connections": {
    urlTemplate: "/settings?tab=integrations",
  },
  "users": {
    urlTemplate: "/admin/users/{id}",
  },
  "website_hosting.website": {
    urlTemplate: "/websites/{id}",
  },
  "websites": {
    urlTemplate: "/websites/{id}",
  },
  "workspace": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
  "workspaces": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
};
